import { render, staticRenderFns } from "./MvnModal.vue?vue&type=template&id=b2b57e26"
import script from "./MvnModal.vue?vue&type=script&lang=js"
export * from "./MvnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports